import type { FC } from 'react'
import type { Project } from '@/types'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'

import { cn } from '@/lib/utils'
import { BoardImage } from '@/components/generals/board-image'

type ProjectCardProps = {
    project: Project
    className?: string
}

export const ProjectCard: FC<ProjectCardProps> = ({ project, className }) => {
    return (
        <Link
            href={`/work/${project.slug}`}
            className={cn('group/card flex w-full flex-col gap-4', className)}
        >
            <div className='relative aspect-square w-full overflow-hidden rounded-2xl bg-ink/6'>
                <BoardImage
                    tile={project.cover}
                    className='absolute inset-0 size-full transition-all duration-700 ease-dentea group-hover/card:scale-[1.06]'
                />
            </div>

            <div className='flex flex-col gap-1'>
                <div className='flex items-center gap-2'>
                    <h3 className='display text-[1.1rem] md:text-[1.3rem]'>{project.name}</h3>

                    <span className='flex w-3.5 justify-end overflow-hidden'>
                        <ArrowRight
                            aria-hidden='true'
                            className='size-3.5 shrink-0 -translate-x-4 opacity-0 transition-all duration-500 ease-dentea group-hover/card:translate-x-0 group-hover/card:opacity-100'
                        />
                    </span>
                </div>

                <p className='label text-ink/50'>{project.sector}</p>
            </div>
        </Link>
    )
}
